import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_portal-login_modal_enter_email-action_unknown';
/**
 * &#x2F;login-modal&#x2F;enter-email
Parameter could be one of these
1. A known email with PW login &quot;PASSWORD&quot;
2. A known email with SSO Login &quot;SSO&quot;
3. An Unknown Email &quot;UNKNOWN&quot;
4. Not Email &quot;NOT_EMAIL&quot;
5. A Faire email (optional) &quot;ADMIN&quot;
*/
export function trackRetailerPortalLoginModalEnterEmail(emailType = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { emailType },
    });
}
